// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host{
    display:flex;
  }
  .custom-header{
    height:36px;
    display:flex;
    align-items: center;
    flex:1 1 auto;
    line-height:27px;
    overflow:hidden;
    z-index: 1;
  }

  .ag-group-expanded,.ag-group-contracted{
    display: inline-block;
    margin-left:11px;
  }
  .header-title{
    overflow:hidden;
    display:flex;
  }
  .group-name{
    overflow: hidden;
    text-overflow: ellipsis;
    flex-grow: 0;
  }
  .action-buttons-container{
    flex-grow: 1;
    display:flex;
    gap:10px;
    justify-content: flex-end;
  }

  .action-buttons{
    display:flex;
    align-items: center;
    justify-content: center;
    width:176px;
    margin-right:12px;
  }

  .icon{
    font-size:20px;
    cursor:pointer;
    color:#526B7A;
  }

  .action-buttons .btn-small{
    padding: 0px 10px;
    font-size: 12px;
    height: 24px;
    box-shadow: 0px 1px 0px 0px #dae2e8;
  }
`, "",{"version":3,"sources":["webpack://./src/app/components/learning-curve-group-renderer/learning-curve-group-renderer.component.css"],"names":[],"mappings":"AAAA;IACI,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,YAAY;EACd;EACA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,YAAY;EACd;EACA;IACE,YAAY;IACZ,YAAY;IACZ,QAAQ;IACR,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,cAAc;IACd,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,mCAAmC;EACrC","sourcesContent":[":host{\n    display:flex;\n  }\n  .custom-header{\n    height:36px;\n    display:flex;\n    align-items: center;\n    flex:1 1 auto;\n    line-height:27px;\n    overflow:hidden;\n    z-index: 1;\n  }\n\n  .ag-group-expanded,.ag-group-contracted{\n    display: inline-block;\n    margin-left:11px;\n  }\n  .header-title{\n    overflow:hidden;\n    display:flex;\n  }\n  .group-name{\n    overflow: hidden;\n    text-overflow: ellipsis;\n    flex-grow: 0;\n  }\n  .action-buttons-container{\n    flex-grow: 1;\n    display:flex;\n    gap:10px;\n    justify-content: flex-end;\n  }\n\n  .action-buttons{\n    display:flex;\n    align-items: center;\n    justify-content: center;\n    width:176px;\n    margin-right:12px;\n  }\n\n  .icon{\n    font-size:20px;\n    cursor:pointer;\n    color:#526B7A;\n  }\n\n  .action-buttons .btn-small{\n    padding: 0px 10px;\n    font-size: 12px;\n    height: 24px;\n    box-shadow: 0px 1px 0px 0px #dae2e8;\n  }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
